import React, {  } from "react";
import { Admin, CustomRoutes, Resource } from "react-admin";
import { Route } from "react-router-dom";
import { PulseLoader } from 'react-spinners';
import Center from 'react-center';
import { AscCodeList, AscCodeShow, AscCodeCreate, AscCodeEdit } from './AscCode';
import { AssessmentList, AssessmentShow, AssessmentEdit, AssessmentCreate } from './Assessment';
import { AwardingBodyList, AwardingBodyShow, AwardingBodyEdit, AwardingBodyCreate } from './AwardingBody';
import { CampusLocationList, CampusLocationShow, CampusLocationCreate, CampusLocationEdit } from './CampusLocation';
import { CostCentreList, CostCentreShow, CostCentreCreate, CostCentreEdit } from './CostCentre';
import { CourseLevelList, CourseLevelShow, CourseLevelEdit, CourseLevelCreate } from './CourseLevel';
import { CountryList, CountryShow, CountryCreate, CountryEdit } from './Country';
import { CreditLevelList, CreditLevelShow, CreditLevelCreate, CreditLevelEdit } from './CreditLevel';
import { CreditValueList, CreditValueShow, CreditValueCreate, CreditValueEdit } from './CreditValue';
import { DeliveryInstitutionList, DeliveryInstitutionShow, DeliveryInstitutionCreate, DeliveryInstitutionEdit } from './DeliveryInstitution';
import { DurationList, DurationShow, DurationCreate, DurationEdit } from './Duration';
import { HECOScodeList, HECOScodeShow, HECOScodeCreate, HECOScodeEdit } from './HecosCode';
import { FacultyList, FacultyShow, FacultyCreate, FacultyEdit } from './Faculty';
import { FacultyGroupList, FacultyGroupShow, FacultyGroupCreate, FacultyGroupEdit } from './FacultyGroup';
import { FacultySubGroupList, FacultySubGroupShow, FacultySubGroupCreate, FacultySubGroupEdit } from './FacultySubGroup';
import { JacsCodeList, JacsCodeShow, JacsCodeCreate, JacsCodeEdit } from './JacsCode';
import { LanguageList, LanguageShow, LanguageCreate, LanguageEdit } from './Language';
import { ModeOfDeliveryList, ModeOfDeliveryShow, ModeOfDeliveryCreate, ModeOfDeliveryEdit } from './ModeOfDelivery';
import { ModeOfStudyList, ModeOfStudyShow, ModeOfStudyCreate, ModeOfStudyEdit } from './ModeOfStudy';
import { ModuleTypeList, ModuleTypeShow, ModuleTypeEdit, ModuleTypeCreate } from './ModuleType';
import { QualificationTypeList, QualificationTypeShow, QualificationTypeCreate, QualificationTypeEdit } from './QualificationType';
import { QualificationAimList, QualificationAimShow, QualificationAimCreate, QualificationAimEdit } from './QualificationAim';
import { PartnershipTypeList, PartnershipTypeShow, PartnershipTypeEdit, PartnershipTypeCreate } from './PartnershipType';
import { ProfessionalBodyList, ProfessionalBodyShow, ProfessionalBodyEdit, ProfessionalBodyCreate } from './ProfessionalBody';
import { ProfessionalBodyTypeList, ProfessionalBodyTypeShow, ProfessionalBodyTypeEdit, ProfessionalBodyTypeCreate } from './ProfessionalBodyType';
import modules from './Module';
import ModuleShow from './Module/ModuleShow';
import { CourseVersionsShow } from "./Course/CourseVersionsShow";
import { ModuleVersionsShow } from "./Module/ModuleVersionsShow";
import courses from './Course';
import courseInstances from './CourseInstance';
import { StatusList, StatusShow, StatusEdit, StatusCreate } from './StatusComponents';
import { InclusiveCurriculumList, InclusiveCurriculumEdit } from './InclusiveCurriculumComponents';
import { ExternalExaminerCreate, ExternalExaminerShow, ExternalExaminerEdit, ExternalExaminerList } from "./ExternalExaminer";
import { Tier4ArrangementCreate, Tier4ArrangementEdit, Tier4ArrangementList, Tier4ArrangementShow } from './Tier4Arrangement';
import { PartnerCollegeList, PartnerCollegeShow, PartnerCollegeCreate, PartnerCollegeEdit } from './PartnerCollege';
import Dashboard from '../dashboard/Dashboard';
import VeroLayout from '../lib/VeroLayout';
import appTheme from "../theme";
import { CourseModulesShow } from "./Course/CourseModulesShow";
import { ApolloProvider } from "@apollo/client";
import associateCourse from "./AssociateCourse";
import researchCourse from "./ResearchCourse";
import ResearchModule from "./Module/ResearchModule";
import ModuleEdit from "./Module/ModuleEdit";
import CourseEdit from "./Course/CourseEdit";
import { useApolloClientDataProvider } from "../useApolloClientDataProvider";




const StaticDataApp = () => {
    const [client, dataProvider, i18nProvider, queryClient] = useApolloClientDataProvider();

    if (!dataProvider) {
        return (
            <div>
                <Center>
                    <div className="loadSplash">
                        <h1> Vero </h1>
                        <div className="loader">
                            <PulseLoader
                                sizeUnit={'px'}
                                size={8}
                                color={'#222222'}
                            />
                        </div>
                    </div>
                </Center>
            </div>
        );
    }

    return (
        <ApolloProvider client={client}>
            <Admin title="Vero Admin" layout={VeroLayout} dataProvider={dataProvider} queryClient={queryClient} dashboard={Dashboard} i18nProvider={i18nProvider} theme={appTheme}>
                <Resource name="Module" {...modules} hasShow={false} />
                <Resource name="ResearchModule" {...ResearchModule}  hasShow={false}/>
                <Resource name="ModuleVersion" show={ModuleVersionsShow}  />
                <Resource name="ThisSpecificModuleVersion" edit={ModuleEdit}  hasShow={false}/>
                <Resource name="FilteredModule"  hasShow={false}/>
                <Resource name="Course" {...courses} hasShow={false} />
                <Resource name="ThisSpecificCourseVersion" edit={CourseEdit}  hasShow={false}/>
                <Resource name="CourseInstance" {...courseInstances}  hasShow={false}/>
                <Resource name="AssociateCourse" {...associateCourse}  hasShow={false}/>
                <Resource name="ResearchCourse" {...researchCourse}  hasShow={false}/>
                <Resource name="CourseVersion" show={CourseVersionsShow} />
                <Resource name="User" />
                <Resource name="CourseModule"  hasShow={false}/>
                <Resource name="AscCode" list={AscCodeList} create={AscCodeCreate} edit={AscCodeEdit} />
                <Resource name="Assessment" list={AssessmentList} create={AssessmentCreate} edit={AssessmentEdit} />
                <Resource name="AwardingBody" list={AwardingBodyList} create={AwardingBodyCreate} edit={AwardingBodyEdit} />
                <Resource name="CampusLocation" list={CampusLocationList} create={CampusLocationCreate} edit={CampusLocationEdit} />
                <Resource name="CostCentre" list={CostCentreList} create={CostCentreCreate} edit={CostCentreEdit} />
                <Resource name="Country" list={CountryList} create={CountryCreate} edit={CountryEdit} />
                <Resource name="CourseLevel" list={CourseLevelList} create={CourseLevelCreate} edit={CourseLevelEdit} />
                <Resource name="CreditLevel" list={CreditLevelList} create={CreditLevelCreate} edit={CreditLevelEdit} />
                <Resource name="CreditValue" list={CreditValueList} create={CreditValueCreate} edit={CreditValueEdit} />
                <Resource name="DeliveryInstitution" list={DeliveryInstitutionList} create={DeliveryInstitutionCreate} edit={DeliveryInstitutionEdit} />
                <Resource name="Duration" list={DurationList} create={DurationCreate} edit={DurationEdit} />
                <Resource name="HecosCode" list={HECOScodeList} create={HECOScodeCreate} edit={HECOScodeEdit} />
                <Resource name="Faculty" list={FacultyList} create={FacultyCreate} edit={FacultyEdit} />
                <Resource name="JacsCode" list={JacsCodeList} create={JacsCodeCreate} edit={JacsCodeEdit} />
                <Resource name="Language" list={LanguageList} create={LanguageCreate} edit={LanguageEdit} />
                <Resource name="ModeOfStudy" list={ModeOfStudyList} create={ModeOfStudyCreate} edit={ModeOfStudyEdit} />
                <Resource name="ModeOfDelivery" list={ModeOfDeliveryList} create={ModeOfDeliveryCreate} edit={ModeOfDeliveryEdit} />
                <Resource name="ModuleType" list={ModuleTypeList} create={ModuleTypeCreate} edit={ModuleTypeEdit} />
                <Resource name="PartnerCollege" list={PartnerCollegeList} create={PartnerCollegeCreate} edit={PartnerCollegeEdit} />
                <Resource name="PartnershipType" list={PartnershipTypeList} create={PartnershipTypeCreate} edit={PartnershipTypeEdit} />
                <Resource name="ProfessionalBody" list={ProfessionalBodyList} create={ProfessionalBodyCreate} edit={ProfessionalBodyEdit} />
                <Resource name="ProfessionalBodyType" list={ProfessionalBodyTypeList} create={ProfessionalBodyTypeCreate} edit={ProfessionalBodyTypeEdit} />
                <Resource name="QualificationAim" list={QualificationAimList} create={QualificationAimCreate} edit={QualificationAimEdit} />
                <Resource name="QualificationType" list={QualificationTypeList} create={QualificationTypeCreate} edit={QualificationTypeEdit} />
                <Resource name="FacultyGroup" list={FacultyGroupList} create={FacultyGroupCreate} edit={FacultyGroupEdit} />
                <Resource name="FacultySubGroup" list={FacultySubGroupList} create={FacultySubGroupCreate} edit={FacultySubGroupEdit} />
                <Resource name="Status" list={StatusList} create={StatusCreate} edit={StatusEdit} />
                <Resource name="InclusiveStatement" list={InclusiveCurriculumList} edit={InclusiveCurriculumEdit} />
                <Resource name="ExternalExaminer" list={ExternalExaminerList} edit={ExternalExaminerEdit} create={ExternalExaminerCreate} />
                <Resource name="Tier4Arrangement" list={Tier4ArrangementList} edit={Tier4ArrangementEdit} create={Tier4ArrangementCreate}  />
                <CustomRoutes>
                    <Route path="CourseModules">
                        <Route path=":courseId" element={<CourseModulesShow />} />
                    </Route>
                    {/* <Route path="CourseSearch">
                        <Route path="/CourseSearch" element={<CourseSearch />} />
                    </Route> */}
                </CustomRoutes>
            </Admin>
        </ApolloProvider>
    );

}

export default StaticDataApp;